module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v(_vm._s(_vm.labelName))]) : _c('span', [_vm._v("Loading...")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2779ac32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadButton.vue
// module id = 1278
// module chunks = 160